export default __webpack_public_path__ + "static/media/MERN-3.f982a221.png";